import { useState } from "react";
import { toast } from "sonner";
import { Bell, CheckCircle2, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function WaitlistForm() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const join = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/waitlist", { email });
      setDone(true);
      toast.success("You're on the list. We'll email you when sign-ups open.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Couldn't join the waitlist, please try again");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p data-testid="waitlist-success" className="mt-3 flex items-center gap-2 text-sm text-[#4DE3BF]">
        <CheckCircle2 className="h-4 w-4" /> You're on the list. Check your inbox for a confirmation.
      </p>
    );
  }

  return (
    <form onSubmit={join} data-testid="waitlist-form" className="mt-3 flex gap-2">
      <input data-testid="waitlist-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.co.uk" aria-label="Email for the waitlist"
        className="min-w-0 flex-1 h-10 rounded-xl border border-white/10 bg-[#0D0D0D] px-3 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-[#00C896]/60" />
      <button data-testid="waitlist-submit-button" type="submit" disabled={busy}
        className="shrink-0 inline-flex items-center gap-1.5 h-10 rounded-xl bg-[#00C896] hover:bg-[#00E5AC] px-3.5 text-sm font-semibold text-[#04140D] transition-colors disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Bell className="h-4 w-4" />} Notify me
      </button>
    </form>
  );
}
